import { render, staticRenderFns } from "./serverSelect.vue?vue&type=template&id=2a5c0f3c&scoped=true&"
import script from "./serverSelect.vue?vue&type=script&lang=js&"
export * from "./serverSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c0f3c",
  null
  
)

export default component.exports